export default __webpack_public_path__ + "2c44d885c51cf1c1f8baab640a3c3c15.png";